<template>
  <div class="layout">
    <el-menu
      background-color="#eef1f6"
      text-color="#48576a"
      active-text-color="#ffd04b"
      router
      :default-openeds="openIndex"
    >
      <el-submenu index="Activity-Management">
        <template slot="title">
          <i class="el-icon-message"></i>
          <span>活动管理</span>
        </template>
        <el-menu-item index="/hiringStandList">活动合作报名</el-menu-item>
        <el-menu-item index="/rank">榜单</el-menu-item>
        <el-menu-item index="/enroll">活动报名</el-menu-item>
        <el-menu-item-group>
          <template slot="title">汇说</template>
          <el-menu-item index="/freetalks">汇说活动管理</el-menu-item>
          <el-menu-item index="/freetalks/post">发布汇说活动</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <template slot="title">决战港股</template>
          <el-menu-item index="/hkstocks">决战港股管理</el-menu-item>
          <el-menu-item index="/hkstocks/post">发布决战港股</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <template slot="title">汇路演</template>
          <el-menu-item index="/roadshow">汇路演管理</el-menu-item>
          <el-menu-item index="/roadshow/post">发布汇路演</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <template slot="title">高峰论坛</template>
          <el-menu-item index="/estateforum_back_list"
            >高峰论坛管理</el-menu-item
          >
          <el-menu-item index="/estateforum_cheack">高峰论坛验票</el-menu-item>
          <el-menu-item index="/estateforum/promotion_code"
            >优惠码生成</el-menu-item
          >
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <el-menu
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      router
      :default-openeds="openIndex"
    >
      <el-submenu index="Content-Management">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>活动内容管理</span>
        </template>
        <!-- <el-menu-item-group>
          <template slot="title">议程</template>
          <el-menu-item-group>
            <template slot="title">--上午议程</template>
            <el-menu-item index="/agenda/am/list">上午议程列表</el-menu-item>
            <el-menu-item index="/agenda/am/post">添加上午议程</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <template slot="title">--下午议程</template>
            <el-menu-item index="/agenda/pm/list">下午议程列表</el-menu-item>
            <el-menu-item index="/agenda/pm/post">添加下午议程</el-menu-item>
          </el-menu-item-group>
        </el-menu-item-group>-->
        <el-menu-item-group>
          <template slot="title">嘉宾</template>
          <el-menu-item index="/guest/list">嘉宾列表</el-menu-item>
          <el-menu-item index="/guest/post">增加嘉宾</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <template slot="title">新闻</template>
          <el-menu-item index="/news/list">新闻列表</el-menu-item>
          <el-menu-item index="/news/post">增加新闻</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <template slot="title">花絮</template>
          <el-menu-item index="/shows/list">花絮列表</el-menu-item>
          <el-menu-item index="/shows/post">添加花絮</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <template slot="title">合作伙伴</template>
          <el-menu-item index="/parthers/list">合作伙伴列表</el-menu-item>
          <el-menu-item index="/parthers/post">添加合作伙伴</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <!-- <el-menu background-color="#eef1f6" text-color="#48576a" active-text-color="#ffd04b" router :default-openeds='openIndex'>
    <el-submenu index="CRM-Management">
      <template slot="title">
        <i class="el-icon-message"></i>
        <span>CRM</span>
      </template>
      <el-menu-item-group>
        <template slot="title">CRM</template>
        <el-menu-item index="/crm/list">CRM List</el-menu-item>
        <el-menu-item index="/crm/post">CRM Post</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    </el-menu>-->
    <el-menu
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      router
      :default-openeds="openIndex"
    >
      <el-submenu index="User-Management">
        <template slot="title">
          <i class="el-icon-message"></i>
          <span>用户管理</span>
        </template>
        <el-menu-item-group>
          <template slot="title">后台用户</template>
          <el-menu-item index="/admin/users">后台用户管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: "",
      openIndex: []
    };
  },
  methods: {},
  computed: {},
  mounted() {
    console.log(this.$route);
  }
};
</script>
<style>
.layout {
}

@media (max-width: 1440px) {
  /* .layout{
    zoom: 0.7;
  } */
}
</style>



// WEBPACK FOOTER //
// src/components/backend/nav.vue